import { useMemo } from 'react'

import SearchList from '../../antd/Lists/SearchList'
import EntityBadge, { getEntityRank } from '../Badges/EntityBadge'

const DEFAULT_LABEL = entity => entity.name
const DEFAULT_KEYWORDS = entity => [entity.name]

/** An entity proposed as a duplicate opens the list : one pre-selected halfway down is one nobody ever sees. */
const byPinnedThenRank = pinned => (a, b) => {
  if (pinned !== null && (a.id === pinned || b.id === pinned)) {
    return a.id === pinned ? -1 : 1
  }

  const rankDiff = getEntityRank(a) - getEntityRank(b)

  return rankDiff !== 0 ? rankDiff : (a.name ?? '').localeCompare(b.name ?? '')
}

const EntityList = ({
  entities = [], excluded = null, keywords = DEFAULT_KEYWORDS, maxHeight, pinned = null,
  renderLabel = DEFAULT_LABEL, selected, onSelectedChange
}) => {
  const options = useMemo(() => entities
    .filter(entity => entity.id !== excluded)
    .sort(byPinnedThenRank(pinned))
    .map(entity => ({
      label: (
        <span className='flex-row ai-ctr' style={{ gap: 5 }}>
          {renderLabel(entity)}
          <EntityBadge entity={entity} size='sm' withTooltip />
        </span>
      ),
      value: entity.id,
      tooltip: entity.name,
      keywords: keywords(entity)
    })), [entities, excluded, keywords, pinned, renderLabel])

  return (
    <div className='h-100'>
      <SearchList selected={selected} data={options} maxHeight={maxHeight} onSelectedChange={onSelectedChange} />
    </div>
  )
}

export default EntityList
